interface Env {
  envIds: Array<number>;
}

const environment = {
  namespaced: true,
  state: {
    envIds: []
  } as Env,
  mutations: {
    setEnvIds(state: Env, envIds: Array<number>) {
      state.envIds.length = 0;
      envIds.forEach(e => state.envIds.push(e));
    }
  }
};

export default environment;
